import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { LOADER_OFF, LOADER_ON, PatientPayersActions } from 'src/redux/actions/constant';

import patientService from 'src/services/apiServices/patientService';

const { CREATE_PATIENT_PAYER_REQUEST, CREATE_PATIENT_PAYER_SUCCESS, CREATE_PATIENT_PAYER_FAILURE } =
  PatientPayersActions;

function* createPatientPayer(action: any): SagaReturnType<any> {
  try {
    const response = yield call(patientService.createPatientPayer, action.payload);
    if (response?.status === 201) {
      yield put({ type: CREATE_PATIENT_PAYER_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: CREATE_PATIENT_PAYER_FAILURE, payload: error });
  }
}

function* createPatientPayerSaga() {
  yield takeEvery(CREATE_PATIENT_PAYER_REQUEST, createPatientPayer);
}

export default createPatientPayerSaga;
